export const config = {
  GMAP_API_KEY: import.meta.env.VITE_GMAP_API_KEY || "",
  QUOTATION_REQUEST_DEFAULT_SALES_MANAGER_ID: import.meta.env
    .VITE_QUOTATION_REQUEST_DEFAULT_SALES_MANAGER_ID,
  ORDER_PROFITABILITY_ENABLED:
    import.meta.env.VITE_ORDER_PROFITABILITY_ENABLED === "true",
} as const
